<template>

<div :class="{ modal: true }">

	<div class="modal-wrap">

		<div class="modal-inner">

			<Loading v-if="loading!==''" position="inner" :text="loading" />

			<h2 class="modal-title">{{ title }}<span class="close" @click="close">X</span></h2>

			<div class="modal-inner-scroll">

				<p>Analysis credits are used in the Content &amp; Keywords feature, as well as the Website Analysis feature. Credits are used when requests are run in these features. If credits will be used, you will see the number of credits required next to the relevant 'Run' button.</p>

				<p v-if="loading===''">Each monthly keyword subscription currently comes with <strong>{{analysisCreditsInfo.costs['free-allocation']}} credits</strong> per month, yearly subscriptions come with <strong>{{analysisCreditsInfo.costs['free-allocation-yearly']}} credits</strong> per year (both do not roll over).</p>

				<p>Additional credits can be purchased (please note these are only valid for 1 month).</p>

				<div class="breakdown" v-if="analysisCreditsInfoLoaded">

					<p>A breakdown of the credits used are as follows...</p>

					<h3 class="type-cat-title">Content &amp; Keywords</h3>

					<p class="type-info"></p>

					<div class="type">
						<h4 :class="{type:true, title: true}"><span>Keyword Search</span> <span>Free</span></h4>
					</div>

					<div 
						:class="{type:true}"
						v-for="(type,index) in types" 
						:key="'type-'+index" 
					>

						<h4 :class="{type:true, title: true}"><span v-html="type.label" /> <span v-html="credits(analysisCreditsInfo.costs[type.key])" /></h4>

					</div>

				</div>

			</div>

		</div>

	</div>

</div>

</template>

<script>
import { mapMutations, mapState } from 'vuex'
import Loading from './../Loading.vue'
export default {
	name: 'AnalysisCreditsHow',
	components: {
		Loading
  	},
	props: {},
	data() {

		return {
			types: [
				{ key: 'paa', label: 'People Also Ask' },
				{ key: 'auto', label: 'Auto Suggest' },
				{ key: 'content-ideas', label: 'Supporting Content Ideas' }
			]
		}

	},
	computed: { 
		...mapState('general',['analysisCredits','reloadAnalysisCredits','buyAnalysisCredits','analysisCreditsInfo','analysisCreditsInfoLoaded']),

		title() {

			return "How Do Analysis Credits Work?";

		},
		loading () {

			return this.analysisCreditsInfoLoaded ? '' : 'Loading...';

		}

  	},
	mounted() {

		

	},

	methods: {

		...mapMutations('general',['updateVar']),

		close() {

			this.$emit('close')

		},
		credits (credits) {

			return credits + ' Credit' + (credits==1 ? '' : 's');

		}

	}
}
</script>

<style lang="less" scoped>
@import './../../assets/css/less/_helper.less';
@import './../../assets/css/less/_settings.less';
.modal {
	z-index: 999999;
	.type-cat-title {
		margin-bottom: 5px;
		margin-top: 20px;
	}
	p {
		margin: 0 0 20px;
		padding: 0;
		&.type-info {
			
			margin-bottom:10px;

		}
	}
	.type {

		.title {

			margin-bottom: 5px;
			span {
				display: inline-block;
				&:first-child {
					width: 80%;
					max-width: 200px;
					margin-right: 20px;
				}
			}

		}

	}
}
</style>